import { Theme, ThemeOptions } from '@mui/material'

export const createTypography = (theme: Theme): ThemeOptions['typography'] => ({
  button: {
    textTransform: 'none',
  },

  subtitle1: {
    color: theme.palette.grey[600],
    fontSize: '0.8rem',
  },
})
